export default "__VITE_ASSET__CmnVNts2__"